import { Button, Input } from '@sunstone/ui';
import { Search, X } from 'lucide-react';

interface HelpSearchBarProps {
  value: string;
  onChange: (value: string) => void;
}

export function HelpSearchBar({ value, onChange }: HelpSearchBarProps) {
  return (
    <div className="relative">
      <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder="Search questions and answers…"
        className="pl-9 pr-9"
        aria-label="Search help questions"
      />
      {value && (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="absolute right-1 top-1/2 h-7 w-7 -translate-y-1/2"
          onClick={() => onChange('')}
          aria-label="Clear search"
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
}
